module.exports = __webpack_public_path__ + "img/d-dot-logo.71edec2d.svg";